import React from 'react';
import InteractiveSetupWalkthrough from './InteractiveSetupWalkthrough';
import { HOME_SETUP_WALKTHROUGH_STEPS } from '../../data/homeSetupWalkthrough';

export default function HomeInteractiveSetup() {
    return (
        <InteractiveSetupWalkthrough
            steps={HOME_SETUP_WALKTHROUGH_STEPS}
            sectionId="set-up-sync"
            ariaHeadingId="home-setup-walkthrough-heading"
            idPrefix="home-setup"
            heading="Set up automatic reporting in minutes"
            subtitle="No engineers required—five quick steps, then your reports and connections run on their own. Explore the setup."
            maxW="1240px"
            showBottomBorder
        />
    );
}
